// import React, { useEffect, useState } from "react";
// import { Link } from "react-router-dom";
// import axios from "axios";

// const BASE_URL = "https://ecom.cyberathon.com";

// const ShopAPI2 = () => {
//   const [shopData, setShopData] = useState([]);

//   useEffect(() => {
//     axios
//       .get(`${BASE_URL}/index.php/Blank/list_shop`)
//       .then((res) => setShopData(res.data.data || []))
//       .catch((err) => console.log(err));
//   }, []);

//   // 🔥 REDIRECT LOGIC
//   const getRedirectCategory = (clickedText, mainHeading) => {
//     if (clickedText.toLowerCase() === "more items") {
//       return "MoreItems";
//     }
//     return mainHeading.replaceAll(" ", "");
//   };

//   // 🔥 PARSE SUB_HEADING PROPERLY
//   const parseSubHeading = (subHeading) => {
//     // Agar already array hai, return karo
//     if (Array.isArray(subHeading)) {
//       return subHeading;
//     }
    
//     // Agar string hai, toh parse karo
//     if (typeof subHeading === 'string') {
//       try {
//         const parsed = JSON.parse(subHeading);
//         return Array.isArray(parsed) ? parsed : [];
//       } catch (e) {
//         return [];
//       }
//     }
    
//     return [];
//   };

//   return (
//     <div className="container py-4">
//       <div className="row g-5">

//         {shopData.map((item) => {
//           const subArr = parseSubHeading(item.sub_heading);

//           const half = Math.ceil(subArr.length / 2);
//           const leftItems = subArr.slice(0, half);
//           const rightItems = subArr.slice(half);

//           return (
//             <div className="col-lg-6 col-md-6 col-sm-12" key={item.id}>
//               <div className="card h-100 shadow-sm d-flex flex-row shop_image">

//                 <img
//                   src={`${BASE_URL}/${item.image}`}
//                   className="card-img-left fixed-img"
//                   alt={item.main_heading}
//                 />

//                 <div className="card-body p-3">
//                   <h5 className="card-title fw-bold">
//                     {item.main_heading}
//                   </h5>

//                   <div className="row">

//                     {/* LEFT */}
//                     <div className="col-6">
//                       {leftItems.map((txt, i) => (
//                         <Link
//                           key={i}
//                           to="/products"
//                           state={{
//                             categoryKey:
//                               txt.toLowerCase() === "more items"
//                                 ? "MoreItems"
//                                 : item.main_heading.replaceAll(" ", "")
//                           }}
//                           className={`d-block mb-1 text-decoration-none ${
//                             txt.toLowerCase() === "more items"
//                               ? "bg-icon"
//                               : "text-dark shop_hover"
//                           }`}
//                         >
//                           {txt}
//                         </Link>
//                       ))}
//                     </div>

//                     {/* RIGHT */}
//                     <div className="col-6">
//                       {rightItems.map((txt, i) => (
//                         <Link
//                           key={i}
//                           to="/products"
//                           state={{
//                             categoryKey:
//                               txt.toLowerCase() === "more items"
//                                 ? "MoreItems"
//                                 : item.main_heading.replaceAll(" ", "")
//                           }} 
//                           className={`d-block mb-1 text-decoration-none ${
//                             txt.toLowerCase() === "more items"
//                               ? "bg-icon"
//                               : "text-dark shop_hover"
//                           }`}
//                         >
//                           {txt}
//                         </Link>
//                       ))}
//                     </div>

//                   </div>
//                 </div>

//               </div>
//             </div>
//           );
//         })}

//       </div>
//     </div>
//   );
// };

// export default ShopAPI2;


// import React, { useEffect, useState } from "react";
// import { Link } from "react-router-dom";
// import axios from "axios";

// const BASE_URL = "https://ecom.cyberathon.com";

// const ShopAPI2 = () => {
//   const [shopData, setShopData] = useState([]);

//   useEffect(() => {
//     axios
//       .get(`${BASE_URL}/index.php/Blank/list_shop`)
//       .then((res) => {
//         setShopData(res.data.data || []);
//       })
//       .catch((err) => console.log(err));
//   }, []);

//   // 🔥 PARSE SUB_HEADING PROPERLY
//   const parseSubHeading = (subHeading) => {
//     // Agar already array hai
//     if (Array.isArray(subHeading)) {
//       // Check if array ke items strings hain jo JSON parse ho sakte hain
//       const cleaned = [];
      
//       for (let item of subHeading) {
//         if (typeof item === 'string') {
//           // Check if string looks like JSON array (starts with [ or ")
//           if (item.trim().startsWith('[') || item.trim().startsWith('"')) {
//             try {
//               const parsed = JSON.parse(item);
//               // Agar parsed result array hai, uske items add karo
//               if (Array.isArray(parsed)) {
//                 cleaned.push(...parsed);
//               } else {
//                 cleaned.push(parsed);
//               }
//             } catch (e) {
//               // Parse nahi hua toh original item add karo
//               cleaned.push(item);
//             }
//           } else {
//             // Normal string hai
//             cleaned.push(item);
//           }
//         } else {
//           cleaned.push(item);
//         }
//       }
      
//       return cleaned;
//     }
    
//     // Agar string hai, toh parse karo
//     if (typeof subHeading === 'string') {
//       try {
//         const parsed = JSON.parse(subHeading);
//         // Recursively call again to handle nested encoding
//         return parseSubHeading(parsed);
//       } catch (e) {
//         return [];
//       }
//     }
    
//     return [];
//   };

//   return (
//     <div className="container py-4">
//       <div className="row g-5">

//         {shopData.map((item) => {
//           const subArr = parseSubHeading(item.sub_heading);

//           const half = Math.ceil(subArr.length / 2);
//           const leftItems = subArr.slice(0, half);
//           const rightItems = subArr.slice(half);

//           return (
//             <div className="col-lg-6 col-md-6 col-sm-12" key={item.id}>
//               <div className="card h-100 shadow-sm d-flex flex-row shop_image">

//                 <img
//                   src={`${BASE_URL}/${item.image}`}
//                   className="card-img-left fixed-img"
//                   alt={item.main_heading}
//                 />

//                 <div className="card-body p-3">
//                   <h5 className="card-title fw-bold">
//                     {item.main_heading}
//                   </h5>

//                   <div className="row">

//                     {/* LEFT */}
//                     <div className="col-6">
//                       {leftItems.map((txt, i) => (
//                         <Link
//                           key={i}
//                           to="/products"
//                           state={{
//                             categoryKey:
//                               txt.toLowerCase() === "more items"
//                                 ? "MoreItems"
//                                 : item.main_heading.replaceAll(" ", "")
//                           }}
//                           className={`d-block mb-1 text-decoration-none ${
//                             txt.toLowerCase() === "more items"
//                               ? "bg-icon"
//                               : "text-dark shop_hover"
//                           }`}
//                         >
//                           {txt}
//                         </Link>
//                       ))}
//                     </div>

//                     {/* RIGHT */}
//                     <div className="col-6">
//                       {rightItems.map((txt, i) => (
//                         <Link
//                           key={i}
//                           to="/products"
//                           state={{
//                             categoryKey:
//                               txt.toLowerCase() === "more items"
//                                 ? "MoreItems"
//                                 : item.main_heading.replaceAll(" ", "")
//                           }} 
//                           className={`d-block mb-1 text-decoration-none ${
//                             txt.toLowerCase() === "more items"
//                               ? "bg-icon"
//                               : "text-dark shop_hover"
//                           }`}
//                         >
//                           {txt}
//                         </Link>
//                       ))}
//                     </div>

//                   </div>
//                 </div>

//               </div>
//             </div>
//           );
//         })}

//       </div>
//     </div>
//   );
// };

// export default ShopAPI2;


import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import axios from "axios";

const BASE_URL = "https://ecom.cyberathon.com";

const ShopAPI2 = () => {
  const [shopData, setShopData] = useState([]);

  useEffect(() => {
    axios
      .get(`${BASE_URL}/index.php/Blank/list_shop`)
      .then((res) => {
        setShopData(res.data.data || []);
      })
      .catch((err) => console.log(err));
  }, []);

  // 🔥 PARSE SUB_HEADING PROPERLY - ULTIMATE FIX
  const parseSubHeading = (subHeading) => {
    // Helper function to clean a single item
    const cleanItem = (item) => {
      if (typeof item !== 'string') return item;
      
      // Remove all types of quotes and brackets
      let cleaned = item
        .replace(/^\["|"\]$/g, '')  // Remove [" and "]
        .replace(/^"|"$/g, '')       // Remove starting/ending quotes
        .replace(/\\"/g, '"')        // Replace \" with "
        .replace(/^\[|\]$/g, '');    // Remove [ and ]
      
      return cleaned;
    };

    // Recursive function to deeply parse
    const deepParse = (data) => {
      // If already a clean array of strings
      if (Array.isArray(data)) {
        const result = [];
        
        for (let item of data) {
          if (typeof item === 'string') {
            // Try to parse if it looks like JSON
            if (item.includes('[') || item.includes('{') || item.includes('"')) {
              try {
                const parsed = JSON.parse(item);
                const nested = deepParse(parsed);
                if (Array.isArray(nested)) {
                  result.push(...nested);
                } else {
                  result.push(nested);
                }
              } catch (e) {
                // Not JSON, clean and add
                result.push(cleanItem(item));
              }
            } else {
              result.push(cleanItem(item));
            }
          } else {
            result.push(item);
          }
        }
        
        return result;
      }
      
      // If string, try to parse
      if (typeof data === 'string') {
        try {
          const parsed = JSON.parse(data);
          return deepParse(parsed);
        } catch (e) {
          return cleanItem(data);
        }
      }
      
      return data;
    };

    const result = deepParse(subHeading);
    return Array.isArray(result) ? result : [];
  };

  return (
    <div className="container py-4">
      <div className="row g-5">

        {shopData.map((item) => {
          const subArr = parseSubHeading(item.sub_heading);

          const half = Math.ceil(subArr.length / 2);
          const leftItems = subArr.slice(0, half);
          const rightItems = subArr.slice(half);

          return (
            <div className="col-lg-6 col-md-6 col-sm-12" key={item.id}>
              <div className="card h-100 shadow-sm d-flex flex-row shop_image">

                <img
                  src={`${BASE_URL}/${item.image}`}
                  className="card-img-left fixed-img"
                  alt={item.main_heading}
                />

                <div className="card-body p-3">
                  <h5 className="card-title fw-bold">
                    {item.main_heading}
                  </h5>

                  <div className="row">

                    {/* LEFT */}
                    <div className="col-6">
                      {leftItems.map((txt, i) => (
                        <Link
                          key={i}
                          to="/products"
                          state={{
                            categoryKey:
                              txt.toLowerCase() === "more items"
                                ? "MoreItems"
                                : item.main_heading.replaceAll(" ", "")
                          }}
                          className={`d-block mb-1 text-decoration-none ${
                            txt.toLowerCase() === "more items"
                              ? "bg-icon"
                              : "text-dark shop_hover"
                          }`}
                        >
                          {txt}
                        </Link>
                      ))}
                    </div>

                    {/* RIGHT */}
                    <div className="col-6">
                      {rightItems.map((txt, i) => (
                        <Link
                          key={i}
                          to="/products"
                          state={{
                            categoryKey:
                              txt.toLowerCase() === "more items"
                                ? "MoreItems"
                                : item.main_heading.replaceAll(" ", "")
                          }} 
                          className={`d-block mb-1 text-decoration-none ${
                            txt.toLowerCase() === "more items"
                              ? "bg-icon"
                              : "text-dark shop_hover"
                          }`}
                        >
                          {txt}
                        </Link>
                      ))}
                    </div>

                  </div>
                </div>

              </div>
            </div>
          );
        })}

      </div>
    </div>
  );
};

export default ShopAPI2;